module.exports = __webpack_public_path__ + "img/home-2.395d3771.webp";